import TextField from '@mui/material/TextField';
import { lazy, Suspense } from 'react';
import type { PhoneInputProps } from './phone-input-field.js';

export type { PhoneInputProps } from './phone-input-field.js';

/**
 * The field and its libphonenumber-js metadata — about 60 KiB gzipped with the
 * formatter and the country list — load when a phone field is first drawn, not
 * with the first screen of every app that has a form (docs/decisions/0086).
 */
const PhoneInputField = lazy(() =>
  import('./phone-input-field.js').then((module) => ({ default: module.PhoneInputField })),
);

/** `PhoneInputField`, fetched on first use; until then a field of the same size. */
export function PhoneInput(props: PhoneInputProps) {
  return (
    <Suspense
      fallback={
        <TextField
          fullWidth={props.fullWidth ?? true}
          size={props.size}
          label={props.label}
          helperText={props.helperText}
          value=""
          disabled
          slotProps={{ inputLabel: { shrink: true } }}
        />
      }
    >
      <PhoneInputField {...props} />
    </Suspense>
  );
}
